<span class="badge" [attr.data-variant]="variant" [attr.data-size]="size" [attr.data-outlined]="outlined"
  [attr.data-disabled]="disabled" role="status" [attr.aria-label]="label + (removable ? ', removable' : '')">
  <!-- Icon on left -->
  <span class="badge-icon-left" *ngIf="showLeftIcon" aria-hidden="true">
    <umss-icon [name]="iconName!" [size]="iconSize"></umss-icon>
  </span>

  <!-- Badge text -->
  <span class="badge-label" *ngIf="label">{{label}}</span>

  <!-- Icon on right -->
  <span class="badge-icon-right" *ngIf="showRightIcon" aria-hidden="true">
    <umss-icon [name]="iconName!" [size]="iconSize"></umss-icon>
  </span>

  <!-- Remove button -->
  <button class="badge-remove" *ngIf="removable && !disabled" (click)="onRemoveClick($event)"
    [attr.aria-label]="'Remove ' + label + ' badge'" type="button">
    <umss-icon name="phosphorX" size="12px"></umss-icon>
  </button>
</span>